// Constants for different requests for current reducer
export default {
  branches: 'BRANCHES',
  branch: 'BRANCH',
  branchOptions: 'BRANCH_OPTIONS',
  createBranch: 'CREATE_BRANCH',
  updateBranch: 'UPDATE_BRANCH',
  updateBranchStatus: 'UPDATE_BRANCH_STATUS',
};
